import React from 'react';
import { Image } from 'react-bootstrap';
import Nutrition from '../Images/Banner 2.png';
import './Nutrition.css';

function NutritionProgram() {
  return (
    <div className="bg-page">
      <Image src={Nutrition} fluid className="Banner-Img" />

      <div className="form-section">
        <div className="form-wrapper">
          <iframe
            src="https://docs.google.com/forms/d/e/1FAIpQLSfRBf0z9DkJ3WaKN6rpFCg8l36TGa1yQTBFcmOFqygOLh0UmA/viewform?embedded=true"
            className="google-form"
            frameBorder="0"
            marginHeight="0"
            marginWidth="0"
            title="Nutrition Form"
          >
            Loading...
          </iframe>
        </div>
      </div>
    </div>
  );
}

export default NutritionProgram;